module.exports = __webpack_public_path__ + "static/media/locs.28f6c343.jpeg";